import { Dispatch, useEffect } from 'react';
import { useDispatch } from 'react-redux';

import { MessageType } from 'dashboard/lib/interfaces/Message';
import { showMessage } from 'dashboard/redux/actions/messages';

type ResultCallBack<T> = (data: T) => { message: string; level?: MessageType } | undefined;

interface UseRTKResultHandlerArgs<T> {
  data?: T | null | undefined;
  onResult?: ResultCallBack<T>;
}

export const rtkResultHandlerLogic = <T>(
  data: T | null | undefined,
  dispatch: Dispatch<any>,
  onResult?: ResultCallBack<T>,
) => {
  if (data == null) {
    // Do nothing if there's no data
    return;
  }

  const resultMessage = onResult?.(data);
  if (resultMessage) {
    dispatch(showMessage(resultMessage.message, resultMessage.level || MessageType.Success));
  }
};

/**
 * A hook that triggers a success message when it receives data.
 * Meant to be used in conjunction with RTK hooks to flash messages on success.
 */
export const useRTKResultHandler = <T>({ data, onResult }: UseRTKResultHandlerArgs<T>) => {
  const dispatch = useDispatch();

  useEffect(() => {
    rtkResultHandlerLogic(data, dispatch, onResult);
  }, [data]);
};
